var App = (function ($) {
    "use strict";

    var $window = $(window);

    function init() {

        //Initialize Plugins
        if (typeof $.fn.tabCollapse === 'function') {
            var $tabs = $('.tab-collapse');
            $tabs.tabCollapse({ accordionClass: 'visible-xs tab-accordion' });
        }

        //if (typeof $.fn.InlineForms === 'function') {
        //    $('fieldset[data-action]').InlineForms();
        //}

        if (typeof $.fn.selectpicker === 'function') {
            $('select.selectpicker').selectpicker({
                mobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false
            });

            $('.dropdown-toggle').on('DOMSubtreeModified', function () {
                $(this).addClass('changed');
            });
        }

        //Dropdowns
        $('nav#hamburger-nav-menu div.dropdown').on('focusout', function (e) {
            if (!$.contains(this, e.relatedTarget)) {
                $('body').trigger("click");
            }
        });
    }

    function waitForImagesToLoad(containerSelector) {
        return new Promise((resolve) => {
            const $container = $(containerSelector);
            const $images = $container.find('img');
            const total = $images.length;
            let loaded = 0;

            if (total === 0) {
                resolve();
                return;
            }

            $images.each(function () {
                if (this.complete) {
                    check();
                } else {
                    $(this).on('load error', check);
                }
            });

            function check() {
                loaded++;
                if (loaded === total) {
                    resolve();
                }
            }
        });
    }

    return {
        init: init,
        $window: $window,
        waitForImagesToLoad: waitForImagesToLoad
    };
})(jQuery);


$(function () {
    App.init();
});